import classNames from 'classnames';
import { TextareaHTMLAttributes } from 'react';
import { Textarea as _Textarea } from '../../../components/Textarea';

type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
    text: string;
    onChangeText: (text: string) => void;
};

export function Textarea({
    text,
    onChangeText,
    placeholder = 'Skriv her…',
    className,
    ...props
}: TextareaProps) {
    return (
        <_Textarea
            {...props}
            className={classNames('mt-20', className)}
            placeholder={placeholder}
            value={text}
            onChangeValue={onChangeText}
        />
    );
}
